import * as React from 'react';

import i18n from 'helper/i18n';
import { CardTypeTypes } from 'types/Card';

export type CategoryTitlePropsType = {
	type: CardTypeTypes;
	label?: string;
};

const CategoryTitle = ({ type, label }: CategoryTitlePropsType) => (
	<p className="m-card__topic-text">
		{label ? label : type && i18n(`react.impulsCoach.components.card.${type}.categoryTitle`)}
	</p>
);

CategoryTitle.displayName = 'Card(CategoryTitle)';

export default CategoryTitle;
